import { render, staticRenderFns } from "./ArticleSort.vue?vue&type=template&id=73286858&scoped=true"
import script from "./ArticleSort.vue?vue&type=script&lang=js"
export * from "./ArticleSort.vue?vue&type=script&lang=js"
import style0 from "./ArticleSort.vue?vue&type=style&index=0&id=73286858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73286858",
  null
  
)

export default component.exports